<template>
	<div class="con">
		<!-- <div class="head">
			<div class="head-bot">
				<van-tabs v-model="headActive" @change='headOnChange' color="#27bec4">
					<van-tab title="在院"></van-tab>
					<van-tab title="出院"></van-tab>
				</van-tabs>
			</div>
		</div> -->
		<div class="pay-title">
			<div>押金</div>
			<div>
				<div @click="showPopup">{{currentDate.getFullYear()}}</div>
				<van-popup v-model="show" position="top" custom-style="height: 20%;">
					<van-datetime-picker :max-date="maxDate" type="year" v-model="currentDate" @cancel="onClose()" @confirm="confirmFn(currentDate)" />
				</van-popup>
			</div>
		</div>
		<div class="list" v-if="noImgShow == false">
			<div v-for="(item,index) in list" class="list-con">
				<div class="list-name">{{item.BRXM}}</div>
				<div>就诊科室：{{item.KSMC}}</div>
				<div>主管医生：{{item.ZZYS}}</div>
				<div>主管护士：{{item.ZGHS}}</div>
				<div>病人性质：{{item.BRXZ}}</div>
				<div class="list-time">
					<div>{{item.RYRQ}}</div>
				</div>
				
				<div class="paybtn-disp">
					<div></div>
					<div class="paybtn" @click="paycostBtn(item.ZYH)">押金缴纳</div>
				</div>
				<div class="deposit-list">
					<div v-for="(dep, depIndex) in depositList[0]" class="deposit" v-if="depIndex < depositShowNum" :key="depIndex">押金：￥{{dep.jkje}}</div>
					<div class="depost-more-text" v-if="depositList[0].length > 3" @click="depostShowBtn">更多押金</div>
				</div>
			</div>
			
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无信息~~</div>
		</div>
		
		<div class="backgroundC" v-show="depositBox"></div>
		<div class="depositBox" v-show="depositBox">
			<div>押金缴纳</div>
			<div class="deposit-input"><input v-model="depositMoney" placeholder="输入要缴纳的住院押金" type="number"></div>
			<div class="deposit-bottom">
				<div class="cancel-btn" @click="cancelBtn()">取消</div>
				<div class="confirm-btn" :class="[depositTime != null ? 'confirm-btn-ccc': '']" @click="confirmBtn()">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inpatientPayCost',
		data() {
			return {
				msg: '押金缴纳',
				list: [],
				depositList:[],//押金列表
				depositShowNum: 3,//显示押金条数
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				headActive: 0,
				navList: [{
						id: 0,
						text: "住院清单",
						img: require('../assets/inHospital.png'),
						to: '/inpatientDeta'
					},
					{
						id: 1,
						text: "住院信息",
						img: require('../assets/inHospital.png'),
						to: '/inpatientDeta'
					},
					{
						id: 2,
						text: "住院缴费",
						img: require('../assets/payCost.png'),
						to: '/inpatientPayCost'
					},
				],
				noImgShow: false,
				depositBox: false,
				depositMoney: '',
				depositTime: null,
				depositZYH: '',//住院号
				timer: null,
				show: false,
				currentDate: new Date(),
				maxDate: new Date(),
			}
		},
		methods: {
			//住院清单
			GetInpatient() {
				this.$store.commit('Load', true)
				this.noImgShow = false;
				let stanum = this.headActive + 1;
				//				this.$Axios.Get('/inpatient? + '&status=' + stanum, null).then(data => {
				this.$Axios.Get('/inpatient/inpatient?name='+this.cardUserInfo.name+'&sfzh='+this.cardUserInfo.sfzh+'&status=' + stanum, null).then(data => {
					console.log(data)
					this.$store.commit('Load', false)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							this.list = data.msg;
							let d = data.tbkkList;
							let newArr = [];
							for(let i in d) {
								newArr.push(d[i])
							}
								 console.log(newArr);
							this.depositList = newArr;
							this.noImgShow = false;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.list = '';
						this.noImgShow = true;
					}
					console.log(this.depositList)
				}).catch(err => {
					this.$toast("网络未连接")
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},
			//更多押金
			depostShowBtn(){
				if(this.depositShowNum == 3){
					this.depositShowNum = 100;
				}else{
					this.depositShowNum = 3;
				}
			},
			//缴费
			paycostBtn(zyh) {
				this.depositZYH = zyh;
				this.depositBox = true;
			},
			//押金确定按钮
			confirmBtn() {
				let that = this;
				clearTimeout(this.depositTime)
			
				this.depositTime = setTimeout(function() {
					let money = Number(that.depositMoney);
					if (money <= 0 || money == null || money == '') {
						that.$toast('请输入缴纳押金')
						that.depositTime = null;
						return false;
					}
					that.$toast('请稍等！');
					that.$Axios.Post( that.$Axios.wxUrl + '/wxpay/payOrder?brid=' + that.cardUserInfo.brid + '&ghxh=undefiend' + '&sfzh=' + that.cardUserInfo
						.sfzh + '&name=' + that.cardUserInfo.name + '&zyh=' + that.depositZYH + '&status=' + 1 + '&zjje=' + money +
						'&payType=2' + '&year=' + that.currentDate.getFullYear() + '&wxje=' + money + '&openid=' + that.cardUserInfo.wechatId,
						null).then(res => {
						console.log(res)
						if (res.data.code == 0) {
							that.depositBox = false;
							that.depositMoney = '';
							const pay_params = res.data.data;
							if (typeof WeixinJSBridge === "undefined") {
								that.$toast('请在手机操作！');
								if (document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
								} else if (document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
								}
							} else {
								that.onBridgeReady(pay_params);
							}
						} else {
							that.$toast(res.data.msg)
							
							that.depositBox = false;
						}
					})
					
				}, 300)
			},
			onBridgeReady(params) {
				var that = this
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": params.appId, //公众号名称，由商户传入
						"timeStamp": params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
						"nonceStr": params.nonceStr, //支付签名随机串，不长于 32 位
						"package": params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
						"signType": 'MD5', //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
						"paySign": params.paySign, //支付签名
					},
					function(res) {
						console.log(res)
						if(res.err_msg == "get_brand_wcpay_request:ok" ){
						  // 使用以上方式判断前端返回,微信团队郑重提示：
								//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
								// that.$router.push('/inpatientPayCost');
								that.$toast('支付成功')
						  } else{
								that.$toast('支付失败')
						  }
						setTimeout(function() {
							that.$router.go(0);
						}, 300);
						that.depositTime = null;
					});
			},
			
			showPopup() {
				this.show = true;
			},
			
			onClose() {
				this.show = false;
			},
			confirmFn(e) {
				this.currentDate = e;
				this.show = false;
				this.GetInpatient()
			},
			//押金取消按钮
			cancelBtn() {
				this.depositMoney = '';
				this.depositBox = false;
			},
			//导航
			headOnChange(event) {
				this.headActive = event;
				this.GetInpatient();
			},
			//查询
			QueryBtn(e) {
				console.log(this.list[e].ZYH)
				this.$router.push({
					path: '/inpatientDeta',
					query: {
						id: this.list[e].ZYH
						
					}
				})
			},
			dro() {
				this.GetInpatient();
			},
			//检验清单
			InspeBtn(e) {
				console.log(this.list[e].ZYH)
				this.$router.push({
					path: '/report',
					query: {
						id: this.list[e].ZYH,
						type: 0,//0、住院 1、门诊
					}
				})
			},

		},
		mounted() {
			this.GetInpatient()
		},
		created() {},
	}
</script>

<style scoped>
	.head {
		padding: 0 0 10px 0;
		position: relative;
		font-size: 15px;
	}
	.pay-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}
	
	.card {
		padding: 30px 20px;
		margin: 10px auto;
		position: relative;
		width: 80%;
		background-color: #fff;
		border: 1px solid #27BEC4;
		box-shadow: 2px 2px 2px #27BEC4;
		font-size: 16px;
		overflow: hidden;
	}
	
	.ca-di {
		padding: 10px;
		display: flex;
		align-items: center;
		border: 1px solid #27BEC4;
		width: 100px;
		border-radius: 5px;
	}
	
	.card-text {
		width: 60%;
	}
	
	.card img {
		position: absolute;
		right: 0;
		top: 0;
		width: 150px;
		height: 170px;
	}
	
	.nav-list {
		padding: 10px 0;
		display: flex;
		justify-content: space-around;
		background-color: #fff;
		font-size: 15px;
	}
	
	.nav-big {
		text-align: center;
	}
	
	.nav-big img {
		width: 50px;
		height: 50px;
	}
	
	.list {
		position: relative;
		flex: 1;
		overflow-y: auto;
		background-color: #FFFFFF;
	}
	
	.list-con {
		position: relative;
		margin: 10px 20px;
		padding: 5px;
		font-size: 15px;
	}
	
	.list-con div {
		margin-bottom: 10px;
	}
	
	.list-name {
		padding: 5px;
		border-left: 5px solid #27BEC4;
		font-weight: 700;
	}
	
	.list-time {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		color: #999;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.queryBtn {
		position: absolute;
		right: 0;
		top: 10px;
		text-align: center;
		color: #27BEC4;
		font-size: 12px;
	}
	
	.inspection {
		display: inline;
		padding: 5px 10px;
		border-radius: 5px;
		background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
		color: #fff;
	}
	.paybtn-disp {
		display: flex;
		justify-content: space-between;
	}
	
	.paybtn {
		display: inline-block;
		margin-top: 5px;
		padding: 5px 10px;
		font-size: 14px;
		color: #fff;
		border-radius: 15px;
		background-color: #27BEC4;
	}
	.depost-more-text{
		position: absolute;
		right: 0;
		bottom: -10px;
		color: #999;
		font-size: 12px;
		z-index: 10;
	}
	.backgroundC {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: #ccc;
		opacity: 0.5;
		z-index: 5;
	}
	.depositBox {
		padding: 20px 10px 10px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 80%;
		height: 130px;
		background-color: #fff;
		border-radius: 18px;
		text-align: center;
		color: #000000;
		z-index: 10;
	}
	
	.deposit-input {
		margin: 20px 0;
	}
	
	.deposit-input input {
		padding: 4px;
	}
	
	.deposit-bottom {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.cancel-btn {
		color: #ff0000;
	}
	.confirm-btn-ccc{
		color: #1296DB;
	}
	/*修改提示文字的颜色*/
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #666666;
		font-size: 12px;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #666666;
		font-size: 12px;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #666666;
		font-size: 12px;
	}
	
	input:-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #666666;
		font-size: 12px;
	}
</style>